import { useQuery } from "react-query";
import axiosConfig from "../config/axios";

const fetchCategories = async () => {
  const { data } = await axiosConfig.get(
    "/categories?pageNumber=1&pageSize=100"
  );

  return data;
};

export const useFetchCategories = () => {
  const { data, isLoading } = useQuery("categories", fetchCategories);

  return { data, isLoading };
};
